import React, { Component } from 'react';
import Input from '../UI/Input/Input';
import classes from './SplitPickup.css';


class SplitPickup extends Component {

    inputBlurredHandler = (event, mulchType) => {
        this.props.loading(mulchType.toLowerCase(),event.target.value);
    }

    inputChangedHandler = (event, mulchType) => {
        this.props.loading(mulchType.toLowerCase(),event.target.value);
    }

render () {
    if (this.props.mulchType == 'TYPE') {
        return (
            <div className={classes.SplitPickup}>
                <div className={classes.LeftSide}>
                    <strong>TYPE</strong>
                </div>
                <div className={classes.MiddleSide}>
                    <strong>REMAINING</strong>
                </div>
                <div className={classes.RightSide}>
                    <strong>LOAD</strong>
                </div>
            </div>
            
            )
    }
    else if (this.props.mulchType == 'TOTAL') {
        return (
            <div className={classes.SplitPickup}>
                <div className={classes.LeftSide}>
                    <strong>TOTAL</strong>
                </div>
                <div className={classes.MiddleSide}>
                    <strong>{this.props.totalRemaining}</strong>
                </div>
                <div className={classes.RightSide}>
                    <strong>{this.props.totalTaken}</strong>
                </div>
            </div>
            
            )
    }
    else {
    return (
    <div className={classes.SplitPickup}>
        <div className={classes.LeftSide}>
             <strong>{this.props.mulchType}</strong>
        </div>
        <div className={classes.MiddleSide}>
             <strong>{this.props.remaining}</strong>
        </div>
        <div className={classes.RightSide}>
            <Input key={this.props.remaining}
        elementType='input'
        elementConfig={{
            type: 'text',
            placeholder: this.props.remaining
        }}                
            blurred={(event) => this.inputBlurredHandler(event, this.props.mulchType)}
            changed={(event) => this.inputChangedHandler(event, this.props.mulchType)} />
        </div>
    </div>
    
    )
    }
}

}

export default SplitPickup;


// WEBPACK FOOTER //
// ./src/components/SplitPickup/SplitPickup.js